export default __webpack_public_path__ + "static/media/company_logo_icon.dd5be0f6.png";